let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hZ6ln")).then(() => parcelRequire('fHZfE'));